import {
    NodesAction, SelectedNodesAction
} from "../actions";
import {Node} from "../model";
import {combineReducers} from "redux";

const Nodes = (state: Array<Node> = [], action: NodesAction) => {
    switch (action.type) {
        case "INIT_NODES":
            return action.initialState;
        default:
            return state;
    }
};


const SelectedNodes = (state: Array<number> = [], action: SelectedNodesAction) => {
    switch (action.type) {
        case "SET_SELECTED_NODES":
            return action.newState;
        default:
            return state;
    }
};



export default combineReducers({SelectedNodes, Nodes});